import { render, staticRenderFns } from "./ProjectPanel.vue?vue&type=template&id=65efce5c&"
import script from "./ProjectPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectPanel.vue"
export default component.exports